/** Значение, которое умеет уехать в строку запроса */
type QueryValue =
  | string
  | number
  | boolean
  | undefined
  | null
  | QueryValue[]
  | { [key: string]: QueryValue };

/**
 * Строка запроса со вложенными объектами в формате qs:
 * `filter[medicationForm][names][0]=Таблетки`. Штатный сериализатор RTK Query
 * этого не умеет. Пустые значения пропускаются.
 */
function buildQueryString(params: Record<string, QueryValue>): string {
  const parts: string[] = [];

  const append = (key: string, value: QueryValue) => {
    if (value === undefined || value === null || value === '') return;

    if (Array.isArray(value)) {
      value.forEach((item, index) => append(`${key}[${index}]`, item));
      return;
    }

    if (typeof value === 'object') {
      Object.entries(value).forEach(([nested, item]) =>
        append(`${key}[${nested}]`, item)
      );
      return;
    }

    parts.push(
      `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    );
  };

  Object.entries(params).forEach(([key, value]) => append(key, value));

  return parts.join('&');
}

/** Путь с параметрами: `/v5/products/search?regionFiasId=…` */
export function withQuery(
  url: string,
  params: Record<string, QueryValue>
): string {
  const query = buildQueryString(params);
  return query ? `${url}?${query}` : url;
}
